import React from 'react';

import { DirectionType } from '../../types';

import { UpButton } from './UpButton';
import { RightButton } from './RightButton';
import { DownButton } from './DownButton';
import { LeftButton } from './LeftButton';
import { Wrapper } from './Wrapper';
import { Arrow } from './Arrow';

interface IProps {
    onArrowClick(direction: DirectionType): void;
    style?: React.CSSProperties;
}

export const ArrowPad: React.FC<IProps> = ({ onArrowClick, style }) => (
    <Wrapper style={{ ...style }}>
        <UpButton onClick={() => onArrowClick('up')}>
            <Arrow />
        </UpButton>
        <RightButton onClick={() => onArrowClick('right')}>
            <Arrow />
        </RightButton>
        <DownButton onClick={() => onArrowClick('down')}>
            <Arrow />
        </DownButton>
        <LeftButton onClick={() => onArrowClick('left')}>
            <Arrow />
        </LeftButton>
    </Wrapper>
);
